import Programmer from '../../pic/pngegg.png'
import bgImage222 from '../../pic/paper-wallpaper.jpg'
import breaklineLeft from '../../pic/brakeLine.png'
import breaklineRight from '../../pic/brakeLine2.png'

import './home.css'

import { MdOutlineAlternateEmail } from "react-icons/md";
import { TiSocialLinkedinCircular } from "react-icons/ti";
import { AiFillGithub } from "react-icons/ai";


export default function HeroSection(){
    return(
        <div className={`w-screen lg:h-[48rem] md:h-[39rem] h-screen flex flex-col justify-center relative overflow-hidden`}>
            {/* <img src={bgImage222} alt="" className=' absolute z-0 w-full h-full filter-blur block lg:hidden md:hidden ri'/> */}
            <div className='flex lg:flex-row md:flex-row flex-col 
                            lg:justify-evenly md:justify-evenly justify-center 
                            pt-16 pb-8 z-20 bg-black bg-opacity-40  md:bg-gradient-to-r lg:bg-gradient-to-r  
                            lg:mt-16 md:mt-7 mt-0 
                            h-screen lg:h-fit md:h-fit' >
                <div className='flex flex-col lg:ms-36 md:ms-10 ms-5 justify-center pb-20 
                                lg:text-start md:text-start text-center' >
                        <div className='font-bold text-white text-anime'>
                            <h3 className='text-black lg:text-3xl md:text-xl text-xl lg:block md:block hidden'>Hi, I am</h3>
                            <h3 className=' lg:text-3xl md:text-xl text-xl lg:hidden md:hidden block text-anime3'>My Name Is Kerlos</h3>
                            <h1 className='  text-black lg:text-7xl md:text-4xl text-4xl mt-2 lg:block md:block hidden'>Kerlos Magdy</h1>
                            <h1 className=' lg:text-7xl md:text-4xl text-4xl mt-2 lg:hidden md:hidden block text-anime4'>I`M A FRONT-END DEVELOPER</h1>
                            <h4 className='lg:text-[#999999] md:text-[#999999] text-white lg:text-3xl md:text-2xl text-xl mt-2 lg:block md:block hidden'>Front-end Developer</h4>
                        </div>
                        <div className='lg:hidden md:hidden flex flex-row w-full justify-center mt-4'>
                            <img src={breaklineLeft} alt="" className='w-40 h-8 me-4'/>
                            <img src={breaklineRight} alt="" className='w-40'/>
                        </div>
                        <div className='flex flex-row lg:justify-start md:justify-start justify-center mt-5 text-anime2'>
                            <a href="mailto: kerlosssony@gmail.com" target="_blank" className='lg:text-4xl md:text-2xl text-xl mx-5 px-3 py-3 bg-[#c4c4c4] rounded-full' rel="noreferrer">
                            <MdOutlineAlternateEmail />
                            </a>
                            <a href="https://github.com/KerlosSoNy?tab=repositories" target="_blank" className='lg:text-4xl md:text-2xl text-xl mx-5  px-3 py-3 p-2 bg-[#c4c4c4] rounded-full' rel="noreferrer">
                                <AiFillGithub />
                            </a>
                            <a href="https://www.linkedin.com/in/kerlos-m-61759a105/" target="_blank" className='lg:text-5xl md:text-4xl text-3xl mx-5 p-2 bg-[#c4c4c4] rounded-full' rel="noreferrer">
                                <TiSocialLinkedinCircular />
                            </a>
                        </div>
                </div>
                <div className='lg:block md:block hidden'>
                    <img src={Programmer} alt="" className='lg:w-96 md:w-80 w-56 lg:h-full md:h-96 sm:h-72 mb-10'/>
                </div>
            </div>
        </div>
    )
}